<template>
<div id="cont_mea_header" class="container-fluid px-0">
	<nav class="navbar navbar-expand-lg navbar-light bg-light border border-secondary border-left-0 border-right-0 border-top-0">
		<a class="navbar-brand" href="https://mymea.org/utilities/rates/">
			<span class="h2 pr-2">
				<img src="https://mymea.org/img/mea_logo/MEA_Primary_Red.png" alt="MEA" height="60px" >
			</span>
			<span id="header_title" class="h4 font-weight-normal p1-2 d-none d-sm-inline-block" style="border-left:1px solid #000000; height: 80%;">
				MESSA Rates and Renewals
			</span>
		</a>

		<button class="navbar-toggler collapse" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			<span class="navbar-toggler-icon"></span>
		</button>

		<ProfileMenu :name="displayName"/>
		
	</nav>
</div>
	
</template>

<script>
/* eslint-disable */
import ProfileMenu from './ProfileMenu/ProfileMenu.vue';
export default {
	name: "Navbar",
	props:{
		displayName: String,
	},
	components: { ProfileMenu },
}
</script>

<style>

/* cont_mea_header */
#cont_mea_header{
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.container-fluid{
	width: 100%;
	padding-right: 15px;
	padding-left: 15px;
	margin-right: auto;
	margin-left: auto;
}

/* <nav> element */
.navbar{
	position: relative;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	padding: 0.5rem 1rem;
}

.bg-light{
	background-color: rgb(248, 249, 250);
}

.border{
	border: 1px solid #dee2e6!important;
}

.border-top-0{
	border-top: 0!important;
}

.border-right-0{
	border-right: 0!important;
}

.border-left-0{
	border-left: 0!important;
}

.border-secondary{
	border-color: #6C757D!important;
}

/* navbar-brand */
a{
	text-decoration: none;
	background-color: transparent;
}

.navbar-brand{
	display: inline-block;
	padding-top: 0.3125rem;
	padding-bottom: 0.3125rem;
	margin-right: 1rem;
	font-size: 1.25rem;
	line-height: 28px;
	white-space: nowrap;
}

.navbar-brand, .navbar-nav > li > a{
	text-shadow: 0 1px 0 rgb(255 255 255 / 25%);
}

.navbar-light, .navbar-brand{
	color: rgba(0, 0, 0, 0.9);
}

/* navbar header */
.h2, h2 {
    font-size: 2rem;
}


/* logo */
img {
	vertical-align: middle;
	border-style: none;
}

/* navbar text */
.h4, h4 {
    font-size: 1.5rem;
}

.pl-2, .px-2 {
    padding-left: 0.5rem!important;
}

.font-weight-normal {
    font-weight: 400!important;
}

#header_title{
	color: rgba(0, 0, 0, 0.9);
	display: inline-block;
	height: 28.7969px;
	margin-bottom: 8px;
	padding-left: 8px;
}

</style>